export const GET_PAYMENT = '@PAYMENT/GET_PAYMENT'
